import React from "react";
import ProjectDetailPage from "../../components/ProjectDetail";

export default function ProjectDetail() {
  return <ProjectDetailPage />;
}
